
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from "./core/core.module";
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {BlockUIModule} from 'ng-block-ui';
import {BlockUIHttpModule} from 'ng-block-ui/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './service/messaging.service';
// import { environment } from '../environments/environment';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule  } from '@angular/material/core';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { ToastrModule } from 'ngx-toastr';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import { BrowserModule } from '@angular/platform-browser';

// import { ToastrModule } from 'ngx-toastr';
import { PingBshpService } from './service/ping-bshp.service';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    AppComponent,
    ],
 
  imports: [BrowserModule, AppRoutingModule, CoreModule, BrowserAnimationsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    NgSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MomentDateModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BlockUIModule.forRoot({
      message: 'Loading...'
      }),
      BlockUIHttpModule.forRoot(),
      MatProgressBarModule,
      NgIdleKeepaliveModule.forRoot(),
      MomentModule,
      ToastrModule.forRoot(),
       RecaptchaV3Module,ReactiveFormsModule
  ],
    
  providers: [ MessagingService,AsyncPipe,PingBshpService,
    {
          provide: RECAPTCHA_V3_SITE_KEY,
          useValue: '6LcvOU4rAAAAADSer-apdkpVlSOOm8M05DbJ8hgs' 
        }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
